import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    financerAll: [],
    financer: {},
    currentPage: 1,
    totalPages: 1,
    rowsPerPage: 10,
    sortBy: "name",
    sortOrder: "asc",
};

const financerSlice = createSlice({
    name: "financer",
    initialState,
    reducers: {
        setFinancerAll: (state, action) => {
            state.financerAll = action.payload;
        },
        setFinancer: (state, action) => {
            state.financer = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
    },
});

export const {
    setFinancerAll,
    setFinancer,
    setCurrentPage,
    setTotalPages,
    setRowsPerPage,
} = financerSlice.actions;

export default financerSlice.reducer;
